import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import { useMemo } from "react";
import { useRealmApp } from "../RealmApp";
import { mapToEntity } from "../helpers/dataHelper";

const useTaxes = () => {
  const app = useRealmApp();
  const { taxes, loading } = useAllTaxes(app.currentUser.id);
  const taxMap = useMemo(() => mapToEntity(taxes), [taxes]);
  return {
    loading,
    taxes,
    taxMap,
  };
};

export default useTaxes;

function useAllTaxes(ownerId) {
  //
  const { data, loading, error } = useQuery(
    gql`
      query getTaxes($ownerId: String!) {
        taxes(query: { owner_id: $ownerId }) {
          _id
          name
          percentage
          taxBaseName
          taxInvoiceName
          code
          updateDatetime
          creationDatetime
        }
      }
    `,
    { variables: { ownerId } }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const taxes = data?.taxes ?? [];
  return { taxes, loading };
}
